import TextareaAutosize from "react-textarea-autosize";
import {AiFillCloseCircle} from 'react-icons/ai';
export default function Adduser({setOpen,loading,account,handleChange,create,changeDp}) {
  const inputstyle = "border-2 border-gray-500 rounded-md";
  const pstyle = "text-sm font-Roboto tracking-wider font-bold";
  return (
    <div className="m-auto mt-4 shadow-xl p-10"  >
         <AiFillCloseCircle className="scale-150 cursor-pointer" onClick={()=>setOpen(false)}/>
      <div className="flex space-x-4  w-[50%] m-auto">
        <div className="flex flex-col space-y-4">
          <p className={pstyle}>FirstName</p>
          <p className={pstyle}>Last Name</p>
          <p className={pstyle}>Email</p>
          <p className={pstyle}>Mobile</p>
          <p className={pstyle}>Address</p>
          
        </div>
        <div className="flex flex-col space-y-2">
          <input type="text" className={inputstyle} value={account["firstname"] || ""} onChange={(e)=>handleChange("firstname",e.target.value)}/>
          <input type="text" className={inputstyle}  value={account["lastname"] || ""} onChange={(e)=>handleChange("lastname",e.target.value)} />
          <input type="email" className={inputstyle}  value={account["email"] || ""} onChange={(e)=>handleChange("email",e.target.value)}/>
          <input type="mobile" className={inputstyle}  value={account["mobile"] || ""} onChange={(e)=>handleChange("mobile",e.target.value)}/>
          <TextareaAutosize minRows={3} maxRows={6} className={inputstyle} />
         <div className="flex"> <p className={pstyle}>profile pic</p> <input type="file" onChange={changeDp}/></div>
          <button class="bg-indigo-500 shadow-lg shadow-indigo-500/50 p-1 rounded-md  font-Roboto font-bold text-white "
      disabled={loading}
      onClick={create}
      >
        Submit user
      </button>
        </div>
      </div>
     
    </div>
  );
}
